export default {
  // summary
  summaryData: '/api/summary/',
  viewSummaryData: '/api/view/summary/',

  // session
  yandexAuth: '/api/auth/',
  viewAuth: '/api/auth/jwt-session-tokens/',
  refreshToken: '/api/auth/token/refresh/',
  userProfileInfoData: '/api/users/direct-account-info/',
  viewUserProfileInfoData: '/api/view/users/direct-account-info/',
  accounts: '/api/auth/accounts/',
  selectAccount: '/api/auth/update-direct-login/',

  // log
  log: '/api/logs/',
  viewLog: '/api/view/logs/',
  // campaigns
  campaigns: '/api/campaigns/',
  exportCampaignBlacklist: '/api/users/init-blacklist/export',
  // view campaigns
  viewCampaigns: '/api/view/campaigns/',
  // placements
  placements: '/api/placements/',
  disputedPlacements: '/api/placements/disputable/',
  bestPlacements: '/api/placements/best/',
  worstPlacements: '/api/placements/worst/',
  blackListPlacements: '/api/placements/blacklist/',
  whiteListPlacements: '/api/placements/whitelist/',
  // view placements
  viewPlacements: '/api/view/placements/',
  viewDisputedPlacements: '/api/view/placements/disputable/',
  viewBestPlacements: '/api/view/placements/best/',
  viewWorstPlacements: '/api/view/placements/worst/',
  viewBlackListPlacements: '/api/view/placements/blacklist/',
  viewWhiteListPlacements: '/api/view/placements/whitelist/',
  // placements actions
  addBlacklistPlacementsWorst: '/api/placements/blacklist/add/worst/',
  addBlacklistPlacementsDisputed: '/api/placements/blacklist/add/disputable/',
  addBlacklistPlacementsByDomain: '/api/placements/blacklist/add/by-domain/',
  addBlacklistPlacementsByFile: '/api/placements/blacklist/add/by-file/',
  deleteBlacklistPlacements: '/api/placements/blacklist/delete/',
  addAllPlacementsToBlacklist: '/api/placements/blacklist/add/all/',

  addWhitelistPlacementsById: '/api/placements/whitelist/add/by-id/',
  addWhitelistPlacementsByDomain: '/api/placements/whitelist/add/by-domain/',
  addWhitelistPlacementsByFile: '/api/placements/whitelist/add/by-file/',
  deleteWhitelistPlacements: '/api/placements/whitelist/delete/',
  addAllPlacementsToWhitelist: '/api/placements/whitelist/add/all/',

  moveBlacklistPlacementsToWhitelist: '/api/placements/whitelist/switch/',

  // keywords
  keywords: '/api/keywords/',
  viewKeywords: '/api/view/keywords/',
  setKeywordsStatus: '/api/keywords/set-status/',
  exceptionKeywords: '/api/keywords/whitelist/',
  viewExceptionKeywords: '/api/view/keywords/whitelist/',
  addExceptionKeywords: '/api/keywords/whitelist/add/',
  deleteExceptionKeywords: '/api/keywords/whitelist/delete/',
  changeKeywordsStatusFromActionLog: '/api/keywords/whitelist/toggle/',

  // ads
  ads: '/api/promotions/',
  viewAds: '/api/view/promotions/',
  setAdsStatus: '/api/promotions/set-status/',
  exceptionAds: '/api/promotions/whitelist/',
  viewExceptionAds: '/api/view/promotions/whitelist/',
  addExceptionAds: '/api/promotions/whitelist/add/',
  deleteExceptionAds: '/api/promotions/whitelist/delete/',
  changeAdsStatusFromActionLog: '/api/promotions/whitelist/toggle/',

  // settings
  accountSettings: '/api/users/account-settings/',
  viewAccountSettings: '/api/view/users/account-settings/',
  settingJunkNotification: '/api/users/junk-notifications/',
  settingJunkNotificationLimit: '/api/users/junk-notification-limit/',
  settingEnableNotifications: '/api/users/notifications/',
  settingNetworksBanned: '/api/users/disable-networks/',
  settingUpdate: '/api/users/account-settings/update/',

  masks: '/api/users/criterion-masks/',
  notificationEmails: '/api/users/notification-email/'
}
